import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.tr<{ kind?: "head"; noBorder?: boolean }>(
    props =>
        props.kind === "head" && {
            th: {
                borderBottom: props.noBorder ? undefined : theme(props).border.solid,
            },
        }
);
